/** @jsxImportSource @emotion/react */
import * as React from 'react';
import styled from '@emotion/styled';
import { Column } from '../layout/flexbox';
import { IKON_BLUE } from '../styles/colors';
import { UNSELECTABLE_TEXT, XXLargeText } from '../styles/styles';
import ikonLogo from '../assets/images/ikonLogoBlue.svg';
import { getResource } from '../language/resources/getResource';
import { SerializedStyles } from '@emotion/react';


const Logo = styled('img')`
  ${UNSELECTABLE_TEXT};
  width: 300px;
  height: 133.33px;

  @media (max-width: 420px) {
    width: 200px;
    height: 88.88px;
  }
`;

const HeaderText = styled('span')`
  color: ${IKON_BLUE};
  margin-top: 5px;
  margin-bottom: 25px;
  line-height: 1.2;
  ${XXLargeText};
  letter-spacing: 2px;
  ${UNSELECTABLE_TEXT}
`;

/**
 * ResortToolsLogo: a component that renders the IKON logo with 'Resort Tools' text below.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export const ResortToolsLogo: React.FC<{ resources: Record<string, any>, rootCss?: SerializedStyles }> = ({ resources, rootCss: css }) => (
  <Column alignItems='center' justifyContent='center' rootCss={css}>
    <Logo src={ikonLogo} alt='IKON Logo'/>
    <HeaderText>{getResource(resources, 'RESORT_TOOLS_LOGO_HEADER')}</HeaderText>
  </Column>
);
